import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const ResolvableMissionTypeListCmp_AllResolvableMissionTypes_QueryDocument =
  graphql(`
    query ResolvableMissionTypeListCmp_AllResolvableMissionTypes_Query {
      findAllResolvableMissionTypes {
        _id
        code
        label
        categoryParentId
        categoryLeaf
        statusId
      }
    }
  `);

export type ResolvableMissionTypeListCmp_ResolvableMissionType = ResultOf<
  typeof ResolvableMissionTypeListCmp_AllResolvableMissionTypes_QueryDocument
>['findAllResolvableMissionTypes'][number];

export const useFindAllResolvableMissionTypesQuery = (enabled = true) =>
  useGraphQLQuery(
    ResolvableMissionTypeListCmp_AllResolvableMissionTypes_QueryDocument,
    undefined,
    {
      enabled,
    },
  );
